export default class FireflyCanvas {
  constructor(canvasSelector, fireflyCount = 15) {
    this.canvas = document.querySelector(canvasSelector);
    if (!this.canvas) return;

    this.ctx = this.canvas.getContext("2d");
    if (!this.ctx) return;

    this.fireflyCount = fireflyCount;
    this.fireflies = [];
    this.horizon = 0;
    this.animationId = null;

    this.onResize = this.onResize.bind(this);
    this.animate = this.animate.bind(this);

    this.init();
  }

  init() {
    this.setCanvasSize();
    this.createFireflies();
    this.bindEvents();
    this.animate();
  }

  bindEvents() {
    window.addEventListener("resize", this.onResize);
  }

  onResize() {
    this.setCanvasSize();
  }

  setCanvasSize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    this.horizon = window.innerHeight / 2;
  }

  createFireflies() {
    this.fireflies = [];

    for (let i = 0; i < this.fireflyCount; i++) {
      this.fireflies.push(this.createFirefly());
    }
  }

  createFirefly() {
    return {
      x: Math.random() * window.innerWidth,
      y: this.horizon + Math.random() * (window.innerHeight / 2),
      xSpeed: 0.66 + Math.random() * -1.33,
      ySpeed: 0.66 + Math.random() * -1.33,
      lightTimer: 0,
    };
  }

  moveFirefly(firefly) {
    if (firefly.lightTimer < 0) {
      if (
        firefly.x + firefly.xSpeed < 0 ||
        firefly.x + firefly.xSpeed > window.innerWidth
      ) {
        firefly.xSpeed *= -1;
      }

      if (
        firefly.y + firefly.ySpeed < this.horizon ||
        firefly.y + firefly.ySpeed > window.innerHeight
      ) {
        firefly.ySpeed *= -1;
      }

      if (Math.random() < 0.01) {
        firefly.x = Math.random() * window.innerWidth;
        firefly.y = this.horizon + Math.random() * (window.innerHeight / 2);
        firefly.xSpeed = 1 + Math.random() * -2;
        firefly.ySpeed = 1 + Math.random() * -2;
        firefly.lightTimer = 20 + Math.random() * 40;
      }
    }

    firefly.x += firefly.xSpeed;
    firefly.y += firefly.ySpeed;
    firefly.lightTimer--;
  }

  drawFirefly(firefly) {
    if (firefly.lightTimer < 0) return;

    const alpha = Math.sin(Math.PI * (firefly.lightTimer / 60));
    const radius = 1 + Math.random() * 1;

    const light = this.ctx.createRadialGradient(
      firefly.x,
      firefly.y,
      0,
      firefly.x,
      firefly.y,
      radius,
    );

    light.addColorStop(0.5, `rgba(255, 255, 0, ${alpha})`);
    light.addColorStop(1, "rgba(255, 255, 0, 0)");

    this.ctx.fillStyle = light;
    this.ctx.beginPath();
    this.ctx.arc(firefly.x, firefly.y, radius, 0, Math.PI * 2, true);
    this.ctx.fill();
  }

  animate() {
    this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    this.fireflies.forEach((firefly) => {
      this.moveFirefly(firefly);
      this.drawFirefly(firefly);
    });

    this.animationId = requestAnimationFrame(this.animate);
  }

  destroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }

    window.removeEventListener("resize", this.onResize);
  }
}
